import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetReportParameterDetailById = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetDetail?` + params, null);

export const GetReportParameterList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetList?` + params, null);

export const GetInvestigationParameterList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetInvestigationParameterList?` + params, null);

export const GetOPDReportParameterList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetOPDReportParameterList?` + params, null);

export const CreateReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/Create`, data);

export const UpdateReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/Update`, data);

export const DeleteReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/Delete`, data);

export const SaveOPDReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/SaveOPDReportParameter`, data);

export const UpdateOPDReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/UpdateOPDReportParameter`, data);

export const DeleteInvestigationReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/DeleteInvestigationReportParameter`, data);

export const GetAppointmentReportParameterList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetAppointmentReportParameterList?` + params, null);

export const GetOPDReportParameterByOPDList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetOPDReportParameterByOPDList?` + params, null);

export const SavePatientReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/SavePatientReportParameter`, data);

export const UpdatePatientReportParameter = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/UpdatePatientReportParameter`, data);

export const GetPatientReportParameterList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetPatientReportParameterList?` + params, null);

export const GetInvestigationParameterRangeList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/ReportParameter/GetInvestigationParameterRangeList?` + params, null);

export const SaveMemberPatientReportRangeValues = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/SaveMemberPatientReportRangeValues`, data);

export const UpdateMemberPatientReportRangeValues = (data: any) =>
  POST_ENC(`${BASE_URL}/api/ReportParameter/UpdateMemberPatientReportRangeValues`, data);